export const NUMBER_REGEX: RegExp = /^[0-9\b]+$/;
export const PASSWORD_REGEX: RegExp =
  /^(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?0-9])(?=.*[a-z])(?=.*[A-Z]).{12,}$/;
export const EMAIL_REGEX: RegExp =
  /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(ezcloud)\.io$/;
export const VALID_DATE_MMDDYYYY_REGEX: RegExp =
  /(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}/;
export const VALID_DATE_DDMMYYYY_REGEX: RegExp =
  /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
export const NUMBERS_ONLY_REGEX: RegExp = /^[0-9.,]+$/;
export const CURRENCY_REGEX: RegExp = /^[0-9]*\.?[0-9]*$/;
export const NUMBERS_AND_SYMBOLS_REGEX: RegExp = /^[0-9/]+$/;
export const LETTERS_NUMBERS_SYMBOLS_SPACE: RegExp = /^[a-zA-Z0-9_]*$/;
export const LETTERS_NUMBERS_SYMBOLS: RegExp = /^[a-zA-Z0-9!@#$&()[\]{}><?:\s;'`~\\_.+,/"-|=]+$/;
//  /^[\d\s]+(?:\.(?:\s*\d){1,4})?/;
// /^[a-zA-Z0-9!@#$&()\[\]{}><?:;'`~\\_.+,/\"-|=]+$/;
export const NUMBERS_SYMBOLS: RegExp = /^[0-9!@#$&()\\_.+,/"-]+$/;
export const LETTERS: RegExp = /^[a-zA-Z]+$/;
export const NUMBERS_DOT_REGEX: RegExp = /^[0-9]*\.?[0-9]*$/;
export const TIME_MMDDYYYY_REGEX: RegExp = /^\d{2}\/\d{2}\/\d{4}$/;
export const NUMBER_TWO_DECIMAL: RegExp = /^[0-9]*\.?[0-9]*$/;
export const DATE_REGEX: RegExp = /^\d{2}\/\d{2}\/\d{4}$/;
export const NEGATIVE_NUMBERS: RegExp = /^-?\d{1,}(,\d{3})*(\.\d+)?$/;
